/**
 * Animation Config — central spring presets, page variants, stagger constants
 * Every animation component imports from here instead of hardcoding values.
 */

export const springs = {
  gentle:   { type: 'spring' as const, stiffness: 200, damping: 20, mass: 1 },
  bouncy:   { type: 'spring' as const, stiffness: 300, damping: 12, mass: 0.8 },
  snappy:   { type: 'spring' as const, stiffness: 400, damping: 25, mass: 0.6 },
  wobbly:   { type: 'spring' as const, stiffness: 180, damping: 10, mass: 1.2 },
  pageTurn: { type: 'spring' as const, stiffness: 250, damping: 22, mass: 1 },
};

export const stagger = { fast: 0.04, default: 0.06, slow: 0.1 };

export const pageVariants = {
  initial: { opacity: 0, x: 60, scale: 0.96 },
  animate: { opacity: 1, x: 0, scale: 1 },
  exit:    { opacity: 0, x: -60, scale: 0.96 },
};

export const reducedPageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit:    { opacity: 0 },
};

export function staggerContainer(delay = stagger.default) {
  return {
    animate: {
      transition: { staggerChildren: delay, delayChildren: 0.1 },
    },
  };
}

export const staggerItem = {
  initial: { opacity: 0, y: 20, scale: 0.95 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit:    { opacity: 0, y: -10, scale: 0.95 },
};
